// The one place the browser talks to our server. Endpoints are injected into `baseApi` by the slice that owns them.
// Errors come back as { status, message }: the server's own words when it sends { error }, otherwise a plain sentence.
import { createApi, fetchBaseQuery, type BaseQueryFn, type FetchArgs } from '@reduxjs/toolkit/query/react';

export interface ApiError { status: number; message: string }

const raw = fetchBaseQuery({ baseUrl: '/api', credentials: 'same-origin' });

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, ApiError> = async (args, api, extra) => {
  const r = await raw(args, api, extra ?? {});
  if (!r.error) return { data: r.data };
  const e = r.error;
  const status = typeof e.status === 'number' ? e.status : 'originalStatus' in e ? e.originalStatus : 0;
  const body = ('data' in e ? e.data : null) as { error?: string } | null;
  const message = body && typeof body === 'object' && body.error ? body.error
    : status ? `Lookup failed (${status}).` : 'Could not reach the server. Check the connection and try again.';
  return { error: { status, message } };
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: ['Guide'],
  endpoints: () => ({}),
});

export const isApiError = (e: unknown): e is ApiError => !!e && typeof e === 'object' && 'message' in e && 'status' in e;
export const errorText = (e: unknown, fallback = 'Something went wrong.') => (isApiError(e) ? e.message : e instanceof Error ? e.message : fallback);
